<template>
  <div>
    <LoadingOverlay :loading="loading" />
    <div class="position-relative">
      <div
        class="eventCenter-headerSection headerWrapper position-relative d-flex justify-content-between align-items-center"
      >
        <div class="backArrowIcon cursor-pointer" @click="viewClose('someStatus')">
          <img :src="downArrow" alt="Back Arrow" />
        </div>
        <div class="rankingReward-HD">Event Center</div>
      </div>

      <div class="event-cardListWrappers position-relative p-2">
        <div class="event-cardsList">
          <div
            class="event-cards cursor-pointer overflow-hidden bg-white mb-3"
            v-for="reward in CallThisWeekData"
            :key="reward.id"
            @click="openEvent(reward)"
          >
            <div class="event-cardImage position-relative overflow-hidden">
              <img :src="reward.image" class="w-100" alt="" />
            </div>

            <div class="d-flex justify-content-between align-items-center px-3 py-2">
              <div>
                <h6 class="lh-normal fw-semibold mt-0 mb-1">{{ reward.name }}</h6>
                <p class="lh-normal my-0">Long-term-Event</p>
              </div>
              <div class="d-flex align-items-center gap-1">
                <div class="latest-eventCard text-center text-white" v-if="isNewEvent(reward.updated_at)">New</div>
                <div class="angle cursor-pointer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import axios from "axios";
import "./EventCenter.css";
import downArrow from "../../assets/images/back-blackArrow.svg";
import LoadingOverlay from "../LoadingOverlay.vue";

export default {
  name: "EventCenter",
  components: { LoadingOverlay },

  data() {
    return {
      loading: false,
      CallThisWeekData: [],
      downArrow,
      token: "", // ✅ store token here
    };
  },

  mounted() {
    this.fetchCallThisWeekData();
  },

  methods: {
    fetchCallThisWeekData() {
      this.loading = true;

      const tokenParam = this.$route.params.token || "";
      // ✅ correct token extraction
      const token = tokenParam.includes("=")
        ? tokenParam.split("=").pop()
        : tokenParam;

      this.token = token; // ✅ save token for click

      const apiUrl = `/api/getbannerList?type=2`;

      axios
        .get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.CallThisWeekData = response.data.result || [];
        })
        .catch((error) => {
          console.error("Error Fetching Data", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ✅ open event url dynamically on card click with token
    openEvent(reward) {
      if (!reward?.url) return;

      const token = this.token;

      let finalUrl = "";
      // case 1: API already gives "...token="
      if (reward.url.includes("token=")) {
        finalUrl = `${reward.url}${token}`;
      }
      // case 2: url already has query params
      else if (reward.url.includes("?")) {
        finalUrl = `${reward.url}&token=${token}`;
      }
      // case 3: clean url
      else {
        finalUrl = `${reward.url}?token=${token}`;
      }

      // normal browser redirect
      window.location.href = finalUrl;
      // or open in new tab:
      // window.open(finalUrl, "_blank");
    },

    // ✅ check if created_at is within last 30 days
    isNewEvent(updatedAt) {
      if (!updatedAt) return false;

      const createdDate = new Date(updatedAt);
      if (isNaN(createdDate.getTime())) return false;

      const now = new Date();
      const diffMs = now - createdDate;
      const diffDays = diffMs / (1000 * 60 * 60 * 24);

      return diffDays <= 30; // within last 1 month
    },

    viewClose(status) {
      if (window.navigator.userAgent.indexOf("Android") > -1) {
        androidViewClose(status);
      }
    },
  },
};
</script>
